module.exports = __webpack_public_path__ + "static/media/logo-오스템임플란트.f8650b86.png";